import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnimatedCounter from '../AnimatedCounter'
import styles from '../../../../styles.scss'

class Server extends Component {
    // On click events
    onClick() {
        if (this.props.noMenu) return

        // Toggle the menu no matter what
        this.props.toggleMenu()

        // If inactive server was clicked, switch servers!
        if (!this.props.isActive) {
            this.switchServer()
        }
    }

    switchServer() {
        // If the server state is not open, or if the requested server
        // is already active server, do nothing
        if (this.props.isActive || !this.props.isOpen) return null

        // Update the active server
        this.props.setActiveServer(this.props.serverId)

        // Check if we're using the same origin (hostname)
        const regex = new RegExp(`${window.location.host}`, 'gi')

        // We're trying to go to the same origin, no refresh
        if (this.props.websiteUrl.match(regex)) return

        // Create the path & hash
        const pathname = window.location.pathname
        const search = window.location.search
        const hash = `#server:${this.props.serverId}`

        // Combine the path & hash
        const urlParameters = pathname + search + hash

        // Update the URL of the launcher
        window.location.replace(`${this.props.websiteUrl}${urlParameters}`)

        // Update the given token
        window.setToken()
    }

    renderPlayerCount() {
        // If the server is disabled
        if (!this.props.enabled) return null

        return <AnimatedCounter serverId={this.props.serverId} />
    }

    renderServerStatus() {
        // If the server is disabled or shouldn't show status
        if (!this.props.enabled || !this.props.showStatus) return null

        return (
            <span className={`${styles[this.props.status]} ${styles.status}`}>
                {this.props.statusText}
            </span>
        )
    }

    renderTestServer() {
        if (!this.props.isTestServer) return null

        return <span className={styles.testServer}>{this.props.testServerText}</span>
    }

    render() {
        const status = this.renderServerStatus()
        const playerCount = this.renderPlayerCount()
        const renderTestServer = this.renderTestServer()

        // Create the caret
        const caret =
            this.props.isActive && !this.props.noMenu ? (
                <FontAwesomeIcon icon="caret-down" fixedWidth />
            ) : null

        return (
            <a
                role="button"
                tabIndex="0"
                onClick={() => this.onClick()}
                onKeyPress={() => this.onClick()}
                key={this.props.serverId}
            >
                <li>
                    <span className={styles.server_name}>{this.props.name}</span>
                    {renderTestServer}
                    {caret}
                    <br />
                    {status}
                    {playerCount}
                </li>
            </a>
        )
    }
}

Server.propTypes = {
    isActive: PropTypes.bool,
    isTestServer: PropTypes.bool,
    testServerText: PropTypes.string,
    isOpen: PropTypes.bool,
    toggleMenu: PropTypes.func,
    setActiveServer: PropTypes.func,
    showStatus: PropTypes.bool,
    status: PropTypes.string,
    statusText: PropTypes.string,
    name: PropTypes.string,
    serverId: PropTypes.string,
    websiteUrl: PropTypes.string,
    enabled: PropTypes.bool,
    noMenu: PropTypes.bool,
}

export default Server



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/Server/component.js